var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cus-chat-supervise" },
    [
      _c(
        "div",
        { staticClass: "cus-chat-supervise-search" },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "150px" },
              attrs: { placeholder: "请选择", size: "mini" },
              on: { change: _vm.selectBindStatus },
              model: {
                value: _vm.formInline.bindStatus,
                callback: function($$v) {
                  _vm.$set(_vm.formInline, "bindStatus", $$v)
                },
                expression: "formInline.bindStatus"
              }
            },
            _vm._l(_vm.options, function(item) {
              return _c("el-option", {
                key: item.bindStatus,
                attrs: { label: item.label, value: item.bindStatus }
              })
            }),
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                width: "250px",
                display: "inline-block",
                "margin-left": "12px"
              }
            },
            [
              _c(
                "el-input",
                {
                  attrs: {
                    size: "mini",
                    placeholder: "档案名/卡号/昵称/备注名",
                    clearable: ""
                  },
                  on: { blur: _vm.onInputBlur, clear: _vm.onInputBlur },
                  model: {
                    value: _vm.formInline.queryCustomerChat,
                    callback: function($$v) {
                      _vm.$set(_vm.formInline, "queryCustomerChat", $$v)
                    },
                    expression: "formInline.queryCustomerChat"
                  }
                },
                [
                  _c("i", {
                    staticClass: "el-input__icon el-icon-search",
                    attrs: { slot: "suffix" },
                    slot: "suffix"
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            [
              _c(
                "el-table",
                {
                  ref: "cusChatTable",
                  staticStyle: { "font-size": "13px" },
                  attrs: {
                    size: "small",
                    data: _vm.tableData,
                    fit: "",
                    "highlight-current-row": "",
                    align: "center",
                    "header-cell-style": { background: "#F9F9F9" },
                    height: _vm.tableHeight
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "客户",
                      "min-width": "150px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(" " + _vm._s(scope.row.name)),
                            scope.row.type == 1
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: { color: "rgb(70, 189, 10)" }
                                  },
                                  [_vm._v(" @微信")]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticStyle: { color: "rgb(8, 168, 231)" }
                                  },
                                  [_vm._v(" @" + _vm._s(scope.row.corpName))]
                                )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "employee", label: "档案名" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.ctmName != null
                              ? _c("span", [_vm._v(_vm._s(scope.row.ctmName))])
                              : _c(
                                  "span",
                                  {
                                    staticStyle: { color: "rgb(228, 96, 63)" }
                                  },
                                  [_vm._v("未绑定")]
                                )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "ctmCode", label: "卡号" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "chargePerson", label: "跟进员工" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.chargePerson == null
                              ? _c(
                                  "span",
                                  { staticStyle: { color: "#FFAA33" } },
                                  [_vm._v("无跟进员工")]
                                )
                              : _c("span", [
                                  _vm._v(_vm._s(scope.row.chargePerson))
                                ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "recentTime", label: "上次聊天" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.recentTime == null
                              ? _c(
                                  "span",
                                  { staticStyle: { color: "#FFAA33" } },
                                  [_vm._v("无上次聊天时间")]
                                )
                              : _c("span", [
                                  _vm._v(_vm._s(scope.row.recentTime))
                                ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "operation", label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                staticStyle: { "font-size": "13px" },
                                attrs: {
                                  underline: false,
                                  type: "primary",
                                  icon: "el-icon-view"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.viewContent(
                                      scope.$index,
                                      scope.row
                                    )
                                  }
                                }
                              },
                              [_vm._v("聊天内容")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Pagination", {
        attrs: { childMsg: _vm.pageparm, pageSizes: _vm.pageSizes },
        on: { callBack: _vm.callBack }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.chatTitle,
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            width: "70%",
            center: true,
            "close-on-press-escape": true
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close
          }
        },
        [
          _c(
            "div",
            {},
            [
              _vm.newChatDialogVisible
                ? _c("ChatContentDia", { attrs: { idData: _vm.uid } })
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }